export const API_BASE_URL = '/api/userwebsite/';
export const USER_APP_BASE_URL = '/api/userapp/';

export async function fetchAPI(endpoint, options = {}) {
  const url = `${API_BASE_URL}${endpoint}`;
  
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  const config = {
    ...options,
    headers,
  };

  try {
    const response = await fetch(url, config);
    if (!response.ok) {
      throw new Error(`API response error: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`API Fetch Error [${endpoint}]:`, error);
    throw error;
  }
}

export async function fetchUserAppAPI(endpoint, options = {}) {
  const url = `${USER_APP_BASE_URL}${endpoint}`;
  
  const headers = {
    ...options.headers,
  };

  // If the body is FormData (used for file uploads), let the browser set the Content-Type boundary automatically
  if (options.body && !(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  } else if (!options.body) {
    headers['Content-Type'] = 'application/json';
  }

  const config = {
    ...options,
    headers,
  };

  try {
    const response = await fetch(url, config);
    if (!response.ok) {
      throw new Error(`API response error: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`API UserApp Fetch Error [${endpoint}]:`, error);
    throw error;
  }
}
